var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.929.515015 14.141 14.141985-1.414 1.414-3.823-3.822-.833 1.251v8.5h-6v-8.5l-5-7.49999h-1v-2h4.585l-2.07-2.071zm2.656 5.484995h-3.181l4.596 6.89399v7.106h2v-7.106l1.392-2.087zm11.415-2v2h-1l-1.915 2.872-1.442-1.443.953-1.429h-2.383l-2-2z",
    fill: "rgb(0,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFilter);
export default __webpack_public_path__ + "static/media/RemoveFilter.1e60a868b280be76110e6fafb2176fb7.svg";
export { ForwardRef as ReactComponent };